import { createNews } from "@/business/news/application/createNews";
import { deleteNews } from "@/business/news/application/deleteNews";
import { editNews } from "@/business/news/application/editNews";
import { getAllNews } from "@/business/news/application/getAllNews";
import { News } from "@/business/news/domain/news";
import { ref, Ref, onMounted } from "vue";

export function newsUse() {
  const modalInfoNews: Ref<boolean> = ref(false);
  const news: Ref<News[]> = ref([]);
  const selectedNews: Ref<News | null> = ref(null);

  onMounted(async () => {
    await getNewsFromApi();
  });

  async function getNewsFromApi(): Promise<void> {
    news.value = await getAllNews.execute();
  }

  function createNewNews() {
    selectedNews.value = null;
    modalInfoNews.value = true;
  }

  function editNewsSelected(news: News) {
    modalInfoNews.value = true;
    selectedNews.value = news;
  }

  function closeInformationNewsModal() {
    modalInfoNews.value = false;
    selectedNews.value = null;
  }

  async function createNewsOperation(
    title: string,
    body: string,
    image1: File
  ) {
    await createNews.execute(title, body, image1);
    modalInfoNews.value = false;
    await getNewsFromApi();
    selectedNews.value = news.value[0];
  }

  async function editNewsOperation(title: string, body: string, image1: File) {
    await editNews.execute(
      title,
      body,
      image1,
      selectedNews.value?.shortTitle ?? ""
    );
    modalInfoNews.value = false;
    selectedNews.value = null;
    news.value = [];
    await getNewsFromApi();
  }

  async function deleteNewsOperation() {
    const newsToDelete = selectedNews.value;
    if (newsToDelete !== null && newsToDelete.title !== null) {
      await deleteNews.execute(newsToDelete.shortTitle);
      news.value = news.value.filter(
        (news) => newsToDelete.shortTitle !== news.shortTitle
      );
    }
  }

  return {
    modalInfoNews,
    createNewsOperation,
    selectedNews,
    createNewNews,
    editNewsSelected,
    news,
    closeInformationNewsModal,
    editNewsOperation,
    deleteNewsOperation,
  };
}
